module.exports = new __parcel__URL__("notion.8faa4a6c.png").toString();